import { defineMessages } from 'react-intl';

export const voucherPriceMessages = defineMessages({
  DiscountPriceText: {
    id: 'voucherprice.discount.pricetext',
    defaultMessage: '{price} mit Ihrem Rabatt',
  },
  DiscountSubtext: {
    id: 'voucherprice.discount.subtext',
    defaultMessage: 'Ihr Rabatt wird im letzten Bestellschritt automatisch abgezogen.',
  },
});
